import React from 'react';
import { useBoolean } from '~utils/use-boolean';

const { useContext, createContext } = require('react');

const sideNavigationOpenContext = createContext({
  isSideNavigationOpen: null,
  openSideNavigation: null,
  closeSideNavigation: null,
  toggleSideNavigation: null,
});

export const SideNavigationOpenContextProvider = ({ children }) => {
  const [
    isSideNavigationOpen,
    { setTrue: openSideNavigation, setFalse: closeSideNavigation, toggle: toggleSideNavigation },
  ] = useBoolean();

  return (
    <sideNavigationOpenContext.Provider
      value={{
        isSideNavigationOpen,
        openSideNavigation,
        closeSideNavigation,
        toggleSideNavigation,
      }}
    >
      {children}
    </sideNavigationOpenContext.Provider>
  );
};

export const useSideNavigationOpenContext = () => useContext(sideNavigationOpenContext);
